import React from 'react';

import AbstractWrapper from 'components/Entities/EntityRelatedTab/components/AbstractWrapper';
import { BackgroundInformationSections } from 'components/Entities/EntityDetailsTab/styles';
import { EmptyState } from 'components/Entities/EntityAttachmentTab/styles';

const BLOCKS = [
  { title: 'Risk assessments', empty: 'No risk assessments use this hazard' },
  { title: 'Templates', empty: 'No templates have this hazard in their standard hazards' },
];

const HazardRelatedTab: React.FunctionComponent = () => (
  <BackgroundInformationSections>
    {BLOCKS.map(({ title, empty }) => (
      <AbstractWrapper key={title} headerTitle={title} gridElement={<EmptyState>{empty}</EmptyState>} />
    ))}
  </BackgroundInformationSections>
);

export default HazardRelatedTab;
